import { Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  resize: {
    height: '5px',
    cursor: 'row-resize',
  },
}));

/**
 * 要素の高さを変更する
 * @param {number} height 要素の高さ
 * @param {*} setHeight useStateのsetFunc
 * @param {number} minHeight 要素の高さ最小値
 * @param {*} maxHeight 要素の高さ最大値
 */
// 使用例: ダッシュボードの表部分で使っています

export default function ResizeBar(props) {
  const { height, setHeight, minHeight = 0, maxHeight } = props;
  const classes = useStyles();

  const resizeHeight = (event) => {
    const startY = event.clientY;

    const handleMouseMove = (moveEvent) => {
      const newHeight = height + (moveEvent.clientY - startY);
      setHeight(newHeight > minHeight ? newHeight : minHeight); // 最小高さをminHeightに制限
      if (newHeight > maxHeight) setHeight(maxHeight);
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  return (
    <Grid
      className={classes.resize}
      onMouseDown={resizeHeight}
    />
  );
}
